var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 66,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C29B40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007 64.212 5.993 53.797A11.95 11.95 0 0 1 0 43.415v-20.83a11.95 11.95 0 0 1 5.993-10.382L24.007 1.788a12.05 12.05 0 0 1 11.986 0l18.014 10.415A11.95 11.95 0 0 1 60 22.585v20.83a11.95 11.95 0 0 1-5.993 10.382L35.993 64.212a12.05 12.05 0 0 1-11.986 0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 37.585a3.275 3.275 0 0 0 3.275-3.275V19.048a3.275 3.275 0 1 0-6.55 0V34.31A3.275 3.275 0 0 0 30 37.585M30 50.227a4.094 4.094 0 1 0 0-8.188 4.094 4.094 0 0 0 0 8.188"
  }))));
};
export default SvgArrows;